import AuthService, { TokenStorage } from './AuthenticationService';
import {
  AmplifyAuthAdapter,
  ApigeeAuthAdapter,
  HybridAuthAdapter,
} from './AuthenticationService/authAdapters';
import { AuthAdapter } from './AuthenticationService/types';
import config from '../config';
import { resolveApigeeAuthUrl } from './gatewayEndpoint';
import { local } from './storage';

export const createAuthService = (storageKey: string) => {
  const apigeeAdapter = new ApigeeAuthAdapter({
    baseUrl: resolveApigeeAuthUrl,
    clientId: config.apigee.auth.clientId,
  });

  const amplifyAdapter = new AmplifyAuthAdapter();

  let authAdapter: AuthAdapter = amplifyAdapter;
  if (config.auth.type === 'Hybrid') {
    authAdapter = new HybridAuthAdapter(amplifyAdapter, apigeeAdapter);
  }

  const tokensStorage = new TokenStorage(local, storageKey);
  return new AuthService(authAdapter, tokensStorage);
};
